<template>
    <div class="el-main-content el-main-content--full-height">
        <div
            class="el-form-card"
            :class="{ 'el-form-card--collapse': collapseMaterialManager }"
        >
            <div class="el-form-card__header">
                <div
                    class="el-form-card__header-left-icon"
                    @click="collapseMaterialManager = !collapseMaterialManager"
                >
                    <img src="/images/icon/material-manager.png" />
                </div>
                <div class="el-form-card__header-text">
                    {{ $t('form.title.materialManager') }}
                </div>
                <div
                    class="el-form-card__header-right-icon"
                    @click="collapseMaterialManager = !collapseMaterialManager"
                >
                    <img src="/images/icon/minimize.png" />
                </div>
            </div>
            <div
                class="el-form-card__body"
                v-loading="isPackagesLoading"
                element-loading-text="Loading..."
                element-loading-background="#4d5b74"
                style="padding-top: 0 !important"
            >
                <div class="el-form-card__collapse-label">
                    {{ $t('form.title.materialManager') }}
                </div>
                <el-form
                    class="dark-form overflow-scroll"
                    style="height: 700px"
                    label-position="top"
                    label-width="150px"
                    size="mini"
                >
                    <el-row>
                        <div class="el-form-card__package-wrapper">
                            <el-row>
                                <el-col :span="18" :offset="1">
                                    <div style="padding: 5px">
                                        <v-text-field
                                            :label="$t('form.label.search')"
                                            v-model="packageSearchVal"
                                            required
                                        ></v-text-field>
                                    </div>
                                </el-col>
                                <el-col :span="23" :offset="1">
                                    <div style="padding: 5px">
                                        <el-date-picker
                                            width="20%"
                                            style="
                                                border-bottom: 1px solid black !important;
                                                color: #989ea6 !important;
                                            "
                                            id="listDateTimeRange"
                                            v-model="dateTimeRange"
                                            @change="dateTimeRangeChange"
                                            format="yyyy-MM-dd"
                                            size="mini"
                                            type="datetimerange"
                                            range-separator="-"
                                            :clearable="false"
                                            :start-placeholder="
                                                $t('form.label.dateTimeFrom')
                                            "
                                            :end-placeholder="
                                                $t('form.label.dateTimeUntil')
                                            "
                                            :picker-options="pickerOptions"
                                            class="el-date-picker-light"
                                        ></el-date-picker>
                                    </div>
                                    <span
                                        class="el-icon-refresh date-refresh-icon"
                                        @click="resetDate('dateRange1')"
                                    ></span>
                                </el-col>
                                <el-col :offset="1">
                                    <v-switch
                                        style="margin: 5px 0 0 5px"
                                        v-model="filterByInventoryGoods"
                                        :label="
                                            $t('button.text.inventoryGoods')
                                        "
                                        value="filter1"
                                        color="yellow"
                                        hide-details
                                    ></v-switch>
                                </el-col>
                            </el-row>
                            <div
                                class="el-form-card__package-item"
                                v-for="material in searchResults"
                                v-show="material.PackageGroups.length"
                                :key="material.BLCNotificationID"
                                style="margin-top: 10px"
                            >
                                <div
                                    :class="{
                                        'el-form-card__package-title--express':
                                            material.IsExpress,
                                    }"
                                    class="el-form-card__package-title"
                                >
                                    <div
                                        class="el-form-card__package-item-text pr-0"
                                    >
                                        <span>
                                            <a
                                                class="Light_Blue_Color1"
                                                href="#"
                                                @click="
                                                    openMaterialDialog(material)
                                                "
                                            >
                                                {{
                                                    material.DestinationContainer
                                                }}
                                            </a>
                                        </span>
                                        <span class="text-xs-right right mr-3">
                                            {{ $t('form.label.arrived') }}:
                                            {{ material.ActualArrivalDate }}
                                        </span>
                                    </div>
                                    <div
                                        class="el-form-card__package-item-icons"
                                    >
                                        <ul
                                            class="resources-icon-list resources-icon-list--white"
                                        >
                                            <li
                                                v-if="
                                                    material.RequestedResouces &&
                                                    material.RequestedResouces.includes(
                                                        'FORKLIFT'
                                                    )
                                                "
                                                class="resource-icon resource-icon__transporter"
                                            ></li>
                                            <li
                                                v-if="
                                                    material.RequestedResouces &&
                                                    material.RequestedResouces.includes(
                                                        'TRUCK'
                                                    )
                                                "
                                                class="resource-icon resource-icon__truck"
                                            ></li>
                                            <li
                                                v-if="
                                                    material.RequestedResouces &&
                                                    material.RequestedResouces.includes(
                                                        'MANPOWER'
                                                    )
                                                "
                                                class="resource-icon resource-icon__team"
                                            ></li>
                                            <li
                                                v-if="
                                                    material.RequestedResouces &&
                                                    material.RequestedResouces.includes(
                                                        'CRANE'
                                                    )
                                                "
                                                class="resource-icon resource-icon__crane"
                                            ></li>
                                            <li
                                                v-if="
                                                    material.RequestedResouces &&
                                                    material.RequestedResouces.includes(
                                                        'TOOLS'
                                                    )
                                                "
                                                class="resource-icon resource-icon__tools"
                                            ></li>
                                        </ul>
                                    </div>
                                </div>
                                <el-collapse>
                                    <!-- :key="packageGroup.PackageGroupID"
                                    :name="packageGroup.PackageGroupID"-->
                                    <el-collapse-item
                                        v-for="packageGroup in material.PackageGroups"
                                    >
                                        <template slot="title">
                                            <div
                                                class="el-collapse-item__header-content"
                                            >
                                                <div
                                                    class="el-collapse-item__header-text"
                                                >
                                                    <span
                                                        style="
                                                            display: block;
                                                            margin-top: -4px;
                                                        "
                                                    >
                                                        {{
                                                            packageGroup.Reference
                                                        }}
                                                    </span>
                                                    <span
                                                        v-if="
                                                            packageGroup.SupplierName
                                                        "
                                                        style="
                                                            display: block;
                                                            margin-top: -23px;
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                'table.data.label.supplier'
                                                            )
                                                        }}:
                                                        {{
                                                            packageGroup.SupplierName
                                                        }}
                                                    </span>
                                                </div>
                                                <el-tooltip
                                                    class="item"
                                                    effect="dark"
                                                    :content="
                                                        $t(
                                                            'form.label.deletePackageGroup'
                                                        )
                                                    "
                                                    placement="bottom"
                                                >
                                                    <span
                                                        class="el-icon-delete delete-icon"
                                                        @click="
                                                            deletePackageGroup(
                                                                packageGroup
                                                            )
                                                        "
                                                        style="
                                                            margin-right: -30px;
                                                        "
                                                    ></span>
                                                </el-tooltip>
                                            </div>
                                        </template>
                                        <ul
                                            class="el-collapse-item__content-item-list"
                                        >
                                            <draggable
                                                :options="{
                                                    group: `.${material.BLCNotificationID}`,
                                                }"
                                                @sort="movePackageItem"
                                                :class="
                                                    material.BLCNotificationID
                                                "
                                            >
                                                <!--
                                                :key="item.PackageItemID"-->
                                                <li
                                                    v-for="item in packageGroup.PackageItems"
                                                    :data-package-item="
                                                        item.PackageItemID
                                                    "
                                                    :data-package-group="
                                                        packageGroup.PackageGroupID
                                                    "
                                                    v-if="
                                                        item.StatusDescription !==
                                                        'HIDDEN_INVENTORY_TO_STOCK'
                                                    "
                                                    class="el-collapse-item__content-item"
                                                >
                                                    <div
                                                        class="flex cursor-move"
                                                    >
                                                        <div
                                                            class="flex text-left w-1/2"
                                                        >
                                                            <span
                                                                class="move-icon el-icon-rank"
                                                            ></span>
                                                            {{
                                                                item.Description
                                                            }}
                                                            -
                                                            {{
                                                                item.PackageType
                                                            }}
                                                        </div>
                                                        <el-tooltip
                                                            class="item"
                                                            effect="dark"
                                                            :content="
                                                                $t(
                                                                    'form.label.deletePackageItem'
                                                                )
                                                            "
                                                            placement="bottom"
                                                        >
                                                            <span
                                                                class="el-icon-delete delete-icon"
                                                                @click="
                                                                    deletePackageItem(
                                                                        packageGroup,
                                                                        item
                                                                    )
                                                                "
                                                            ></span>
                                                        </el-tooltip>
                                                    </div>
                                                </li>
                                            </draggable>
                                        </ul>
                                    </el-collapse-item>
                                    <div
                                        class="el-collapse-item__content-item-no-item"
                                        v-if="!material.PackageGroups.length"
                                    >
                                        {{ $t('text.noPackagesFound') }}
                                    </div>
                                </el-collapse>
                            </div>
                        </div>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div
            class="el-grid-card el-grid-card--no-style calendar-main-wrapper route-planner-cal-wrapper"
        >
            <div class="el-row el-grid-card__filter-section">
                <div class="el-grid-card__filter-section-left">
                    <v-btn-toggle class="btn-calendar-group">
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-sm"
                            @click="prevDate"
                        >
                            <v-icon dark>keyboard_arrow_left</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                    <el-date-picker
                        class="top-calendar-picker"
                        v-model="date"
                        format="yyyy-MM-dd (dddd)"
                        type="date"
                        :picker-options="pickerOptions"
                        :placeholder="$t('form.label.pickADay')"
                    ></el-date-picker>
                    <v-btn-toggle
                        v-model="activeButton"
                        class="btn-calendar-group"
                    >
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-sm"
                            @click="nextDate"
                        >
                            <v-icon dark>keyboard_arrow_right</v-icon>
                        </v-btn>
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-auto"
                            @click="today"
                            >{{ $t('button.text.today') }}</v-btn
                        >
                        <v-btn
                            flat
                            color="dark"
                            class="btn-calendar-auto"
                            @click="tomorrow"
                            >{{ $t('button.text.tomorrow') }}</v-btn
                        >
                    </v-btn-toggle>
                </div>

                <div class="el-grid-card__filter-section-right">
                    <treeselect
                        v-model="selectedContainers"
                        value-format="object"
                        class="top-multiselect"
                        :multiple="true"
                        :flat="true"
                        :before-clear-all="handleBeforeClearAll"
                        :placeholder="$t('form.label.selectContainers')"
                        :options="containerTree"
                        :normalizer="normalizer"
                    />
                </div>
            </div>
            <el-row class="el-grid-card__check-box-row">
                <el-col :span="8">
                    <v-checkbox
                        hide-details
                        v-model="showSlotBookings"
                        :label="$t('form.label.showSlotBookings')"
                    ></v-checkbox>
                </el-col>
                <el-col :span="8">
                    <v-checkbox
                        hide-details
                        v-model="editSlotBookings"
                        :label="$t('form.label.changeSlotBookingTime')"
                    ></v-checkbox>
                </el-col>
            </el-row>
            <div class="el-row">
                <full-calendar
                    ref="calendar"
                    :config="config"
                    :header="header"
                    :events="bookings"
                    defaultView="agendaDay"
                    @event-created="addBooking"
                    @event-render="renderBooking"
                    @event-selected="selectCalendarBooking"
                    @event-drop="updateBooking"
                    @event-resize="updateBooking"
                />
            </div>
            <button
                class="hidden"
                ref="btnDialog"
                @click.stop="dialog = true"
            ></button>
            <v-dialog
                v-model="dialog"
                transition="dialog-bottom-transition"
                :overlay="false"
                scrollable
                fullscreen
            >
                <v-card>
                    <v-toolbar
                        style="flex: 0 0 auto"
                        dark
                        class="primary el-dark-top-bar"
                    >
                        <v-btn icon @click.native.stop="closeDialog" dark>
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            {{ $t('title.details') }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <div class="el-panel-wrapper">
                        <div class="el-main-content">
                            <div class="el-form-card">
                                <div class="el-form-card__header">
                                    <div
                                        class="el-form-card__header-left-icon"
                                    ></div>
                                    <div class="el-form-card__header-text">
                                        {{ $t('form.title.materialManager') }}
                                    </div>
                                    <div
                                        class="el-form-card__header-right-icon"
                                    ></div>
                                    <el-row>
                                        <el-col :offset="1">
                                            <v-switch
                                                style="text-transform: none"
                                                v-model="filterByContainer"
                                                :label="
                                                    $t('button.text.showAll')
                                                "
                                                color="yellow"
                                                hide-details
                                            ></v-switch>
                                        </el-col>
                                        <el-col :span="22" :offset="1">
                                            <div>
                                                <v-text-field
                                                    style="text-transform: none"
                                                    :label="
                                                        $t('form.label.search')
                                                    "
                                                    v-model="packageSearchVal2"
                                                    required
                                                ></v-text-field>
                                            </div>
                                        </el-col>
                                        <el-col :span="24" :offset="1">
                                            <div>
                                                <el-date-picker
                                                    style="
                                                        border-bottom: 1px solid
                                                            black !important;
                                                    "
                                                    width="20%"
                                                    id="listDateTimeRange"
                                                    v-model="dateTimeRange2"
                                                    @change="
                                                        dateTimeRangeChange2
                                                    "
                                                    format="yyyy-MM-dd"
                                                    size="mini"
                                                    type="datetimerange"
                                                    range-separator="-"
                                                    :clearable="false"
                                                    :start-placeholder="
                                                        $t(
                                                            'form.label.dateTimeFrom'
                                                        )
                                                    "
                                                    :end-placeholder="
                                                        $t(
                                                            'form.label.dateTimeUntil'
                                                        )
                                                    "
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                    class="el-date-picker-light"
                                                ></el-date-picker>
                                                <span
                                                    class="el-icon-refresh date-refresh-icon"
                                                    style="
                                                        float: left;
                                                        margin-top: 10px;
                                                    "
                                                    @click="
                                                        resetDate('dateRange2')
                                                    "
                                                ></span>
                                            </div>
                                        </el-col>
                                        <el-col :offset="1">
                                            <v-switch
                                                style="
                                                    text-transform: none;
                                                    margin-top: 5px;
                                                "
                                                v-model="filterByInventoryGoods"
                                                value="filter2"
                                                :label="
                                                    $t(
                                                        'button.text.inventoryGoods'
                                                    )
                                                "
                                                color="yellow"
                                                hide-details
                                            ></v-switch>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div
                                    class="el-form-card__body"
                                    style="padding-top: 65px !important"
                                >
                                    <el-form
                                        style="
                                            height: 700px;
                                            margin-top: 115px;
                                            overflow-y: auto;
                                        "
                                        label-position="top"
                                        label-width="150px"
                                        size="mini"
                                    >
                                        <el-row>
                                            <div
                                                class="el-form-card__package-wrapper"
                                            >
                                                <div
                                                    class="el-form-card__package-item"
                                                    v-for="material in searchResults2"
                                                    v-show="
                                                        material.PackageGroups
                                                            .length
                                                    "
                                                    :key="
                                                        material.BLCNotificationID
                                                    "
                                                >
                                                    <div
                                                        :class="{
                                                            'el-form-card__package-title--express':
                                                                material.IsExpress,
                                                        }"
                                                        class="el-form-card__package-title"
                                                    >
                                                        <div
                                                            class="el-form-card__package-item-text pr-0"
                                                        >
                                                            <span>
                                                                {{
                                                                    material.DestinationContainer
                                                                }}
                                                            </span>
                                                            <span
                                                                class="text-xs-right right mr-3"
                                                            >
                                                                {{
                                                                    $t(
                                                                        'form.label.arrived'
                                                                    )
                                                                }}:
                                                                {{
                                                                    material.ActualArrival
                                                                        | formatDate
                                                                }}
                                                            </span>
                                                        </div>
                                                        <div
                                                            class="el-form-card__package-item-icons"
                                                        >
                                                            <ul
                                                                class="resources-icon-list resources-icon-list--white"
                                                            >
                                                                <li
                                                                    v-if="
                                                                        material.RequestedResouces &&
                                                                        material.RequestedResouces.includes(
                                                                            'FORKLIFT'
                                                                        )
                                                                    "
                                                                    class="resource-icon resource-icon__transporter"
                                                                ></li>
                                                                <li
                                                                    v-if="
                                                                        material.RequestedResouces &&
                                                                        material.RequestedResouces.includes(
                                                                            'TRUCK'
                                                                        )
                                                                    "
                                                                    class="resource-icon resource-icon__truck"
                                                                ></li>
                                                                <li
                                                                    v-if="
                                                                        material.RequestedResouces &&
                                                                        material.RequestedResouces.includes(
                                                                            'MANPOWER'
                                                                        )
                                                                    "
                                                                    class="resource-icon resource-icon__team"
                                                                ></li>
                                                                <li
                                                                    v-if="
                                                                        material.RequestedResouces &&
                                                                        material.RequestedResouces.includes(
                                                                            'CRANE'
                                                                        )
                                                                    "
                                                                    class="resource-icon resource-icon__crane"
                                                                ></li>
                                                                <li
                                                                    v-if="
                                                                        material.RequestedResouces &&
                                                                        material.RequestedResouces.includes(
                                                                            'TOOLS'
                                                                        )
                                                                    "
                                                                    class="resource-icon resource-icon__tools"
                                                                ></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <el-collapse>
                                                        <draggable
                                                            :list="
                                                                material.PackageGroups
                                                            "
                                                            :options="{
                                                                group:
                                                                    'packages',
                                                            }"
                                                            @end="
                                                                movePackageGroupToActor
                                                            "
                                                        >
                                                            <!--
                                                            -->
                                                            <transition-group>
                                                                <el-collapse-item
                                                                    v-for="packageGroup in material.PackageGroups"
                                                                    :data-package="
                                                                        packageGroup.PackageGroupID
                                                                    "
                                                                    :key="
                                                                        packageGroup.PackageGroupID
                                                                    "
                                                                    :name="
                                                                        packageGroup.PackageGroupID
                                                                    "
                                                                >
                                                                    <template
                                                                        slot="title"
                                                                    >
                                                                        <div
                                                                            class="el-collapse-item__header-content"
                                                                        >
                                                                            <div
                                                                                class="el-collapse-item__header-text"
                                                                            >
                                                                                <p
                                                                                    style="
                                                                                        margin-bottom: -25px;
                                                                                        display: block;
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        packageGroup.Reference
                                                                                    }}
                                                                                </p>
                                                                                <p
                                                                                    v-if="
                                                                                        packageGroup.SupplierName
                                                                                    "
                                                                                >
                                                                                    {{
                                                                                        $t(
                                                                                            'table.data.label.supplier'
                                                                                        )
                                                                                    }}:
                                                                                    {{
                                                                                        packageGroup.SupplierName
                                                                                    }}
                                                                                </p>
                                                                            </div>
                                                                            <el-tooltip
                                                                                class="item"
                                                                                effect="dark"
                                                                                :content="
                                                                                    $t(
                                                                                        'form.label.movePackageGroup'
                                                                                    )
                                                                                "
                                                                                placement="bottom"
                                                                                v-if="
                                                                                    showMovePkgGrpIcon
                                                                                "
                                                                            >
                                                                                <span
                                                                                    class="el-icon-d-arrow-right copy-package-icon"
                                                                                    @click="
                                                                                        movePackageGroupToActor2(
                                                                                            packageGroup.PackageGroupID
                                                                                        )
                                                                                    "
                                                                                    v-if="
                                                                                        showMovePkgGrpIcon
                                                                                    "
                                                                                ></span>
                                                                            </el-tooltip>
                                                                            <el-tooltip
                                                                                class="item"
                                                                                effect="dark"
                                                                                :content="
                                                                                    $t(
                                                                                        'form.label.deletePackageGroup'
                                                                                    )
                                                                                "
                                                                                placement="bottom"
                                                                            >
                                                                                <span
                                                                                    class="el-icon-delete delete-icon"
                                                                                    @click="
                                                                                        deletePackageGroup(
                                                                                            packageGroup
                                                                                        )
                                                                                    "
                                                                                    style="
                                                                                        margin-right: -50px;
                                                                                    "
                                                                                ></span>
                                                                            </el-tooltip>
                                                                        </div>
                                                                    </template>
                                                                    <ul
                                                                        class="el-collapse-item__content-item-list"
                                                                    >
                                                                        <draggable
                                                                            :options="{
                                                                                group: `.${material.BLCNotificationID}`,
                                                                            }"
                                                                            @sort="
                                                                                movePackageItem
                                                                            "
                                                                            :class="
                                                                                material.BLCNotificationID
                                                                            "
                                                                        >
                                                                            <!--                                                                            -->
                                                                            <li
                                                                                v-for="item in packageGroup.PackageItems"
                                                                                :data-package-item="
                                                                                    item.PackageItemID
                                                                                "
                                                                                :data-package-group="
                                                                                    packageGroup.PackageGroupID
                                                                                "
                                                                                v-if="
                                                                                    item.StatusDescription !==
                                                                                    'HIDDEN_INVENTORY_TO_STOCK'
                                                                                "
                                                                                :key="
                                                                                    item.PackageItemID
                                                                                "
                                                                                class="el-collapse-item__content-item"
                                                                            >
                                                                                <div
                                                                                    class="flex cursor-move"
                                                                                >
                                                                                    <div
                                                                                        class="flex text-left w-1/2"
                                                                                    >
                                                                                        <span
                                                                                            class="move-icon el-icon-rank"
                                                                                        ></span>
                                                                                        {{
                                                                                            item.Description
                                                                                        }}
                                                                                        -
                                                                                        {{
                                                                                            item.PackageType
                                                                                        }}
                                                                                    </div>
                                                                                    <el-tooltip
                                                                                        class="item"
                                                                                        effect="dark"
                                                                                        :content="
                                                                                            $t(
                                                                                                'form.label.movePackageItem'
                                                                                            )
                                                                                        "
                                                                                        placement="bottom"
                                                                                        v-if="
                                                                                            showMovePkgItemIcon
                                                                                        "
                                                                                    >
                                                                                        <span
                                                                                            v-if="
                                                                                                showMovePkgItemIcon
                                                                                            "
                                                                                            class="el-icon-d-arrow-right copy-package-icon"
                                                                                            @click="
                                                                                                movePackageItemToActor(
                                                                                                    item.PackageItemID,
                                                                                                    packageGroup.PackageGroupID
                                                                                                )
                                                                                            "
                                                                                            style="
                                                                                                margin-right: 10px;
                                                                                            "
                                                                                        ></span>
                                                                                    </el-tooltip>
                                                                                    <el-tooltip
                                                                                        class="item"
                                                                                        effect="dark"
                                                                                        :content="
                                                                                            $t(
                                                                                                'form.label.deletePackageItem'
                                                                                            )
                                                                                        "
                                                                                        placement="bottom"
                                                                                    >
                                                                                        <span
                                                                                            class="el-icon-delete delete-icon"
                                                                                            @click="
                                                                                                deletePackageItem(
                                                                                                    packageGroup,
                                                                                                    item
                                                                                                )
                                                                                            "
                                                                                        ></span>
                                                                                    </el-tooltip>
                                                                                </div>
                                                                            </li>
                                                                        </draggable>
                                                                    </ul>
                                                                </el-collapse-item>
                                                            </transition-group>
                                                        </draggable>
                                                        <div
                                                            class="el-collapse-item__content-item-no-item"
                                                            v-if="
                                                                !material
                                                                    .PackageGroups
                                                                    .length
                                                            "
                                                        >
                                                            {{
                                                                $t(
                                                                    'text.noPackagesFound'
                                                                )
                                                            }}
                                                        </div>
                                                    </el-collapse>
                                                </div>
                                            </div>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>

                            <div class="el-grid-card">
                                <div>
                                    <div class="el-row">
                                        <el-col :span="14">
                                            <div class="el-row mb-2">
                                                <h2
                                                    class="el-table__inner-title"
                                                >
                                                    {{
                                                        form.unloadingArea
                                                            .Description || ''
                                                    }}
                                                    :
                                                    <span
                                                        class="el-table__inner-title--sub"
                                                    >
                                                        {{
                                                            form.start
                                                                ? form.start.format(
                                                                      'HH:mm'
                                                                  )
                                                                : ''
                                                        }}
                                                        -
                                                        {{
                                                            form.end
                                                                ? form.end.format(
                                                                      'HH:mm'
                                                                  )
                                                                : ''
                                                        }}
                                                    </span>
                                                </h2>
                                            </div>
                                        </el-col>
                                        <el-col :span="10">
                                            <div class="el-row">
                                                <el-col :span="12">
                                                    <div class="el-row">
                                                        <el-col :span="24">
                                                            <div
                                                                class="el-table__inner-title-label"
                                                            >
                                                                <div
                                                                    class="el-row"
                                                                >
                                                                    <el-col
                                                                        :span="
                                                                            6
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'data.label.items'
                                                                            )
                                                                        }}:
                                                                    </el-col>
                                                                    <el-col
                                                                        :span="
                                                                            18
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-size: 12px;
                                                                                color: white;
                                                                            "
                                                                        >
                                                                            {{
                                                                                totalPackageItems
                                                                            }}
                                                                        </span>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-col>
                                                    </div>
                                                    <div class="el-row">
                                                        <el-col :span="24">
                                                            <div
                                                                class="el-table__inner-title-label"
                                                            >
                                                                <div
                                                                    class="el-row"
                                                                >
                                                                    <el-col
                                                                        :span="
                                                                            6
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'table.label.vehicle'
                                                                            )
                                                                        }}:
                                                                    </el-col>
                                                                    <el-col
                                                                        :span="
                                                                            18
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-size: 12px;
                                                                                color: white;
                                                                            "
                                                                        >
                                                                            {{
                                                                                form
                                                                                    .vehicle
                                                                                    .Description
                                                                            }}
                                                                            {{
                                                                                form
                                                                                    .vehicle
                                                                                    .PlateNo
                                                                            }}
                                                                        </span>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-col>
                                                    </div>
                                                </el-col>
                                                <el-col :span="12">
                                                    <div class="el-row">
                                                        <el-col :span="24">
                                                            <div
                                                                class="el-table__inner-title-label"
                                                            >
                                                                <div
                                                                    class="el-row"
                                                                >
                                                                    <el-col
                                                                        :span="
                                                                            8
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'data.label.bookingId'
                                                                            )
                                                                        }}:
                                                                    </el-col>
                                                                    <el-col
                                                                        :span="
                                                                            16
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-size: 12px;
                                                                                color: white;
                                                                            "
                                                                        >
                                                                            {{
                                                                                actor.BookingReference
                                                                            }}
                                                                        </span>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-col>
                                                        <el-col :span="24">
                                                            <div
                                                                class="el-table__inner-title-label"
                                                            >
                                                                <div
                                                                    class="el-row"
                                                                >
                                                                    <el-col
                                                                        :span="
                                                                            8
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'data.label.routeId'
                                                                            )
                                                                        }}:
                                                                    </el-col>
                                                                    <el-col
                                                                        :span="
                                                                            16
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-size: 12px;
                                                                                color: white;
                                                                            "
                                                                        >
                                                                            {{
                                                                                form
                                                                                    .route
                                                                                    .Reference
                                                                            }}
                                                                        </span>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-col>
                                                        <el-col :span="24">
                                                            <div
                                                                class="el-table__inner-title-label"
                                                            >
                                                                <div
                                                                    class="el-row"
                                                                >
                                                                    <el-col
                                                                        :span="
                                                                            8
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'table.label.recipient'
                                                                            )
                                                                        }}:
                                                                    </el-col>
                                                                    <el-col
                                                                        :span="
                                                                            16
                                                                        "
                                                                    >
                                                                        <span
                                                                            style="
                                                                                font-size: 12px;
                                                                                color: white;
                                                                            "
                                                                        >
                                                                            {{
                                                                                form.recipientCompany
                                                                            }}
                                                                            {{
                                                                                form.recipientName
                                                                            }}
                                                                            {{
                                                                                form.recipientPhone
                                                                            }}
                                                                        </span>
                                                                    </el-col>
                                                                </div>
                                                            </div>
                                                        </el-col>
                                                    </div>
                                                </el-col>
                                            </div>
                                        </el-col>
                                    </div>
                                    <div class="el-row flex">
                                        <div class="el-top-input-wrapper mr-4">
                                            <v-select
                                                :items="recipients"
                                                v-model="form.recipient"
                                                item-text="Label"
                                                combobox
                                                return-object
                                                :label="
                                                    $t(
                                                        'form.label.recipientName'
                                                    )
                                                "
                                                required
                                            ></v-select>
                                        </div>

                                        <div
                                            class="el-top-input-wrapper mr-4"
                                            v-if="routes.length"
                                        >
                                            <v-select
                                                :items="routes"
                                                item-text="Reference"
                                                return-object
                                                v-model="form.route"
                                                :label="$t('form.label.route')"
                                                required
                                            ></v-select>
                                        </div>

                                        <div class="el-top-input-wrapper mr-4">
                                            <v-select
                                                :items="form.unloadingAreas"
                                                item-text="Description"
                                                item-value="UnloadingAreaID"
                                                v-model="form.unloadingArea"
                                                return-object
                                                :label="
                                                    $t(
                                                        'form.label.unloadingArea'
                                                    )
                                                "
                                                required
                                            ></v-select>
                                        </div>
                                    </div>

                                    <div class="el-row">
                                        <div
                                            class="el-collapse-item__header-icon-list el-top-icon-wrapper"
                                        >
                                            <ul class="resources-icon-list">
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'FORKLIFT'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__transporter"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'TRUCK'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__truck"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'MANPOWER'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__team"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'CRANE'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__crane"
                                                ></li>
                                                <li
                                                    v-if="
                                                        requestedResources.includes(
                                                            'TOOLS'
                                                        )
                                                    "
                                                    class="resource-icon resource-icon__tools"
                                                ></li>
                                            </ul>
                                        </div>
                                    </div>

                                    <draggable
                                        v-if="editing"
                                        :list="packageGroups"
                                        :options="{ group: 'packages' }"
                                    >
                                        <!--
                                        :key="packageGroup.PackageGroupID"-->
                                        <div
                                            class="el-row"
                                            v-for="packageGroup in packageGroupsWithoutHiddenItems"
                                        >
                                            <div
                                                class="el-package-group-wrapper"
                                            >
                                                <div class="el-row">
                                                    <div class="el-table-info">
                                                        <div
                                                            class="el-table-info__panel"
                                                        >
                                                            <ul>
                                                                <li>
                                                                    {{
                                                                        $t(
                                                                            'table.data.label.ref'
                                                                        )
                                                                    }}:
                                                                    <span
                                                                        v-text="
                                                                            packageGroup.Reference
                                                                        "
                                                                    ></span>
                                                                    <span
                                                                        style="
                                                                            margin-left: 50px;
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                'table.data.label.supplier'
                                                                            )
                                                                        }}:
                                                                    </span>
                                                                    <span
                                                                        v-text="
                                                                            packageGroup.SupplierName
                                                                        "
                                                                    ></span>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div
                                                            class="el-table-info__actions"
                                                        >
                                                            <v-btn
                                                                class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--warning btn btn--flat"
                                                                flat
                                                                v-if="
                                                                    showMovePackageToNotification(
                                                                        packageGroup.PackageItems
                                                                    )
                                                                "
                                                                @click="
                                                                    movePackageToNotification(
                                                                        packageGroup
                                                                    )
                                                                "
                                                            >
                                                                {{
                                                                    $t(
                                                                        'button.text.returnToOriginatingBLCNotification'
                                                                    )
                                                                }}
                                                            </v-btn>
                                                        </div>
                                                    </div>
                                                    <el-table
                                                        :data="
                                                            packageGroup.PackageItems
                                                        "
                                                        class="el-table__inner-editable el-table__inner-editable--no-top-margin readonly"
                                                        style="width: 100%"
                                                        border
                                                        :cell-style="
                                                            changeColumnBgColor
                                                        "
                                                    >
                                                        <el-table-column
                                                            prop="StatusDescription"
                                                            :label="
                                                                $t(
                                                                    'table.column.status'
                                                                )
                                                            "
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.description'
                                                                )
                                                            "
                                                            prop="Description"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.packageType'
                                                                )
                                                            "
                                                            prop="PackageType"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.trackingReference'
                                                                )
                                                            "
                                                            prop="TrackingReference"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.customerReference'
                                                                )
                                                            "
                                                            prop="CustomReference"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.height'
                                                                )
                                                            "
                                                            prop="Height"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.width'
                                                                )
                                                            "
                                                            prop="Width"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.length'
                                                                )
                                                            "
                                                            prop="Length"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            :label="
                                                                $t(
                                                                    'table.column.weight'
                                                                )
                                                            "
                                                            prop="Weight"
                                                            width="100"
                                                        ></el-table-column>
                                                        <el-table-column
                                                            width="50"
                                                            v-if="
                                                                showMovePackageToNotification(
                                                                    packageGroup.PackageItems
                                                                )
                                                            "
                                                        >
                                                            <template
                                                                slot-scope="{
                                                                    row,
                                                                }"
                                                            >
                                                                <el-tooltip
                                                                    class="item"
                                                                    effect="dark"
                                                                    :content="
                                                                        $t(
                                                                            'form.label.returnPackageItem'
                                                                        )
                                                                    "
                                                                    placement="bottom"
                                                                >
                                                                    <span
                                                                        class="el-icon-d-arrow-left"
                                                                        style="
                                                                            cursor: pointer;
                                                                            font-size: 14px;
                                                                        "
                                                                        @click="
                                                                            returnPackageItem(
                                                                                row,
                                                                                packageGroup
                                                                            )
                                                                        "
                                                                    ></span>
                                                                </el-tooltip>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </div>
                                        </div>

                                        <div slot="footer" class="el-row">
                                            <div class="el-draggable-area">
                                                {{ $t('text.dragAndDropArea') }}
                                            </div>
                                        </div>
                                    </draggable>

                                    <div class="el-row">
                                        <div class="el-bottom-btn-panel">
                                            <v-btn
                                                v-if="editing"
                                                class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--warning"
                                                @click="deleteBooking"
                                                flat
                                                >{{
                                                    $t('button.text.delete')
                                                }}</v-btn
                                            >
                                            <v-btn
                                                @click.native.prevent="submit"
                                                :disabled="saving"
                                                class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--primary"
                                                flat
                                                >{{
                                                    $t('button.text.save')
                                                }}</v-btn
                                            >
                                            <v-btn
                                                @click.native.prevent="
                                                    submitAndClose
                                                "
                                                :disabled="saving"
                                                class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--primary"
                                                flat
                                            >
                                                {{
                                                    $t('button.text.saveClose')
                                                }}
                                            </v-btn>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card>
            </v-dialog>
        </div>
        <div
            class="el-form-card el-form-card--right"
            :class="{ 'el-form-card--collapse': collapseRouteManager }"
        >
            <div class="el-form-card__header">
                <div
                    class="el-form-card__header-left-icon"
                    @click="collapseRouteManager = !collapseRouteManager"
                >
                    <img src="/images/icon/route-manager.png" />
                </div>
                <div class="el-form-card__header-text">
                    {{ $t('form.title.routeManager') }}
                </div>
                <div
                    class="el-form-card__header-right-icon"
                    @click="collapseRouteManager = !collapseRouteManager"
                >
                    <img src="/images/icon/minimize.png" />
                </div>
            </div>
            <div class="el-form-card__body">
                <div class="el-form-card__collapse-label">
                    {{ $t('form.title.routeManager') }}
                </div>
                <el-form
                    class="dark-form"
                    label-position="top"
                    label-width="150px"
                    size="mini"
                >
                    <el-row v-if="editing">
                        <div class="el-form-card__element-wrapper">
                            <el-form-item>
                                <h2 class="el-form-card__inner-title--white">
                                    {{ $t('title.text.bLCRoute') }}:
                                    {{ this.route.Reference }}
                                </h2>
                            </el-form-item>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item>
                                <v-select
                                    :items="drivers"
                                    item-text="FullName"
                                    v-model="routeForm.driver"
                                    :label="$t('text.driver')"
                                    return-object
                                    dark
                                    clearable
                                    required
                                ></v-select>
                            </el-form-item>
                        </div>
                    </el-row>
                    <el-row>
                        <div class="el-form-card__element-wrapper">
                            <el-form-item>
                                <v-select
                                    :items="vehicles"
                                    item-text="FullDescription"
                                    v-model="routeForm.vehicle"
                                    :label="$t('text.vehicle')"
                                    return-object
                                    dark
                                    clearable
                                    required
                                ></v-select>
                            </el-form-item>
                        </div>
                    </el-row>
                    <div
                        class="button-wrapper flex justify-between items-center"
                    >
                        <v-btn
                            round
                            color="primary"
                            :disabled="saving"
                            @click="submitRoute"
                            dark
                        >
                            {{
                                editing
                                    ? $t('button.text.update')
                                    : $t('button.text.save')
                            }}
                        </v-btn>
                        <v-btn round color="dark" @click="resetRoute" dark>{{
                            $t('form.button.cancel')
                        }}</v-btn>
                    </div>
                    <div
                        class="form-expanded-content form-expanded-content__form-element"
                        v-if="routes.length"
                    >
                        <div
                            class="router-list-item"
                            v-for="r in routes"
                            :key="r.BLCRouteID"
                            :class="{
                                'router-list-item--selected':
                                    r.BLCRouteID == route.BLCRouteID,
                                Status_Success:
                                    r.StatusDescription === 'DELIVERY_COMPLETE',
                                Status_Partial:
                                    r.StatusDescription === 'DELIVERY_PARTIAL',
                            }"
                        >
                            <div class="router-list-item__radio">
                                <div class="el-radio-list">
                                    <v-radio-group v-model="route">
                                        <v-radio
                                            color="success"
                                            :value="r"
                                            hide-details
                                        ></v-radio>
                                    </v-radio-group>
                                </div>
                            </div>
                            <div class="router-list-item__details">
                                <div class="router-list-item__details">
                                    <div
                                        class="el-row router-list-item__details-lg-row"
                                    >
                                        <div
                                            class="router-list-item__details-label"
                                        >
                                            {{ $t('text.bLCRoute') }}
                                        </div>
                                        <div
                                            class="router-list-item__details-value"
                                        >
                                            : {{ r.Reference }}
                                        </div>
                                    </div>
                                    <div class="el-row">
                                        <div
                                            class="router-list-item__details-label"
                                        >
                                            {{ $t('text.driver') }}
                                        </div>
                                        <div
                                            class="router-list-item__details-value truncate"
                                            :title="r.DriverUserFullName"
                                        >
                                            : {{ r.DriverUserFullName }}
                                        </div>
                                    </div>
                                    <div class="el-row">
                                        <div
                                            class="router-list-item__details-label"
                                        >
                                            {{ $t('text.vehicle') }}
                                        </div>
                                        <div
                                            class="router-list-item__details-value truncate"
                                            :title="r.VehicleDescription"
                                        >
                                            : {{ r.VehicleDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="router-list-item__actions">
                                <div
                                    class="router-list-item__actions-delete"
                                    @click="deleteRoute(r)"
                                ></div>
                                <div
                                    class="router-list-item__actions-edit"
                                    @click="editRoute(r)"
                                ></div>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>

        <!-- Material Manager Dialog - Single BLCNotification -->
        <div>
            <stc-dialog v-model="materialDialog" @change="closeMaterialDialog">
                <component
                    v-bind:is="materialManagerListComponent"
                    :with-permission="false"
                    :isBLCNotificationList="false"
                    :notification="blcNotification"
                ></component>
            </stc-dialog>
        </div>
        <!--End of Material Manager Dialog - Single BLCNotification -->
    </div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'
import { DateTime } from 'luxon'
import { mapGetters } from 'vuex'
import draggable from 'vuedraggable'
import FullCalendar from '../../Calender'
import Treeselect from '@riophae/vue-treeselect'
import RoutePlannerMilkrunEventComponent from './RoutePlannerMilkrunEvent'
import RoutePlanerSlotEventComponent from './RoutePlanerSlotEvent'
import InteractWithSchedules from '../../../mixins/interact-with-schedules'
import MaterialManagerList from '../material-manager/MaterialManagerList'
import StcDialog from '../../Dialog'
import moment from 'moment'

let RoutePlannerMilkrunEvent = Vue.extend(RoutePlannerMilkrunEventComponent)
let RoutePlanerSlotEvent = Vue.extend(RoutePlanerSlotEventComponent)

export default {
    name: 'route-planner',

    data() {
        let today = DateTime.local().toJSDate()
        let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

        return {
            dateTimeFormat,
            activeButton: 1,
            filterByContainer: false,
            filterByInventoryGoods: false,
            date: today,
            dialog: false,
            dropped: false,
            editing: false,
            saving: false,
            showSlotBookings: true,
            editSlotBookings: false,
            collapseMaterialManager: false,
            collapseRouteManager: false,
            routes: [],
            dataMaterials: [],
            driversData: [],
            vehiclesData: [],
            bookingsData: [],
            gatesData: [],
            containers: [],
            packageGroups: [],
            recipientData: [],
            selectedContainers: [],
            originalPackageGroups: [],
            allUnloadingAreas: [],
            ContainerID: '',
            header: {
                left: '',
                center: '',
                right: '',
            },
            actor: {
                ActorID: '',
                AccessSets: [],
            },
            route: {
                BLCRouteID: '',
                Reference: '',
                VehicleID: '',
            },
            form: {
                start: '',
                end: '',
                route: '',
                gates: [],
                inGate: '',
                outGate: '',
                vehicle: '',
                pinCode: '',
                PlateNo: '',
                recipient: '',
                schedule: {
                    Description: '',
                    ScheduleParts: [
                        {
                            ValidFrom: null,
                            ValidTo: null,
                            WeekStart: 0,
                            WeekStop: 0,
                            IsSimpleSchedule: true,
                        },
                    ],
                },
                dateTimeRange: '',
                unloadingArea: '',
                recipientName: '',
                recipientPhone: '',
                recipientCompany: '',
                requestedResources: [],
                unloadingAreas: [],
                ActorStatus: 0,
            },
            routeForm: {
                driver: '',
                vehicle: '',
            },
            normalizer(node) {
                let data = {
                    id: node.ContainerID,
                    label: node.Description,
                }

                if (node.Children && node.Children.length) {
                    return {
                        ...data,
                        children: node.Children,
                    }
                }

                return data
            },
            materialManagerListComponent: '',
            materialDialog: false,
            blcNotification: undefined,
            packageSearchVal: '',
            packageSearchVal2: '',
            searchResults: [],
            searchResults2: [],
            isPackagesLoading: false,
            dateTimeRange: [],
            dateTimeRange2: [],
            currentRangeStart: '',
            currentRangeStart2: '',
            currentRangeEnd: '',
            currentRangeEnd2: '',
            showMovePkgGrpIcon: true,
            showMovePkgItemIcon: true,
        }
    },

    async created() {
        this.isPackagesLoading = true
        this.fetchDrivers()
        this.fetchVehicles()
        await this.fetchMaterials()

        await Promise.all([
            this.fetchRoutes(),
            this.fetchAllContainers(),
            this.fetchAllUnloadingAreas(),
        ])
        this.selectedContainers = this.filledContainers

        this.fetchBookings()

        this.updatePackageGroupSearchList()
    },

    mixins: [InteractWithSchedules],

    components: {
        'full-calendar': FullCalendar,
        draggable: draggable,
        treeselect: Treeselect,
        'stc-dialog': StcDialog,
        'stc-material-manager-list': MaterialManagerList,
    },

    watch: {
        selectedContainer: function () {
            this.fetchRoutes()
            this.fetchDrivers()
            this.fetchVehicles()
            this.fetchMaterials()
        },

        route: function () {
            this.$refs.calendar.$emit('rerender-events')
        },

        selectedContainers: async function () {
            await this.fetchBookings()

            this.$refs.calendar.fireMethod('refetchResources')
        },

        date: async function () {
            this.route = {
                BLCRouteID: '',
                Reference: '',
            }

            this.fetchMaterials()

            await this.fetchRoutes()
            this.selectedContainers = this.filledContainers
            await this.fetchBookings()

            this.$refs.calendar.fireMethod('gotoDate', this.date)
        },

        'form.recipient': function (recipient) {
            if (_.isObject(recipient)) {
                this.form.recipientName =
                    recipient.FirstName + ' ' + recipient.LastName
                this.form.recipientCompany = recipient.Company
                this.form.recipientPhone = recipient.Phone
            } else {
                this.form.recipientName = recipient
            }
        },
        packageSearchVal: _.debounce(async function () {
            if (this.packageSearchVal !== '') {
                this.searchResults = await this.$search(
                    this.packageSearchVal,
                    this.orderedMaterials,
                    this.searchOptions
                )
                if (this.currentRangeStart && this.currentRangeEnd) {
                    this.searchResults = _.filter(this.searchResults, (item) =>
                        moment(
                            moment(item.ActualArrival).format('YYYY-MM-DD')
                        ).isBetween(
                            this.currentRangeStart,
                            this.currentRangeEnd,
                            'days',
                            '[]'
                        )
                    )
                }
            } else {
                this.updatePackageGroupSearchList()
                if (this.currentRangeStart && this.currentRangeEnd) {
                    this.searchResults = _.filter(this.searchResults, (item) =>
                        moment(
                            moment(item.ActualArrival).format('YYYY-MM-DD')
                        ).isBetween(
                            this.currentRangeStart,
                            this.currentRangeEnd,
                            'days',
                            '[]'
                        )
                    )
                }
            }
        }, 500),
        packageSearchVal2: _.debounce(async function () {
            if (this.packageSearchVal2 !== '') {
                this.searchResults2 = await this.$search(
                    this.packageSearchVal2,
                    this.filteredMaterials,
                    this.searchOptions
                )
                if (this.currentRangeStart2 && this.currentRangeEnd2) {
                    this.searchResults2 = _.filter(
                        this.searchResults2,
                        (item) =>
                            moment(
                                moment(item.ActualArrival).format('YYYY-MM-DD')
                            ).isBetween(
                                this.currentRangeStart2,
                                this.currentRangeEnd2,
                                'days',
                                '[]'
                            )
                    )
                }
            } else {
                this.searchResults2 = this.filteredMaterials
                if (this.currentRangeStart2 && this.currentRangeEnd2) {
                    this.searchResults2 = _.filter(
                        this.searchResults2,
                        (item) =>
                            moment(
                                moment(item.ActualArrival).format('YYYY-MM-DD')
                            ).isBetween(
                                this.currentRangeStart2,
                                this.currentRangeEnd2,
                                'days',
                                '[]'
                            )
                    )
                }
            }
        }, 500),
        filterByContainer: function (val) {
            if (val) {
                this.searchResults2 = this.materials
            } else {
                const results = this.materials.filter(
                    (item) =>
                        item.DestinationContainerID ===
                        this.form.unloadingArea.ContainerID
                )
                this.searchResults2 = results
            }
        },
        filterByInventoryGoods: function (val) {
            if (val) {
                let filteredMaterialsWithInventory = []
                this.materials.forEach((material) => {
                    if (material.PackageGroups) {
                        const items = material.PackageGroups.filter((group) => {
                            return group.PackageItems.some(
                                (item) =>
                                    item.StatusDescription ===
                                    'HIDDEN_INVENTORY_TO_STOCK'
                            )
                        })
                        if (items.length > 0) {
                            let newMaterial = _.cloneDeep(material)
                            newMaterial.PackageGroups = items
                            filteredMaterialsWithInventory.push(newMaterial)
                        }
                    }
                })
                if (val === 'filter1') {
                    this.searchResults = filteredMaterialsWithInventory
                } else {
                    this.searchResults2 = filteredMaterialsWithInventory
                }
            } else {
                this.searchResults = this.materials
                this.searchResults2 = this.materials
            }
        },
    },
    computed: {
        ...mapGetters(['containerTree', 'selectedContainer']),

        searchOptions() {
            return {
                keys: [
                    'DestinationContainer',
                    'PackageGroups.Reference',
                    'PackageGroups.OrderNo',
                    'PackageGroups.SupplierName',
                    'PackageGroups.PackageItems.PackageType',
                    'PackageGroups.PackageItems.Reference',
                    'Actors.PackageGroups.Reference',
                    'Actors.PackageGroups.OrderNo',
                    'Actors.PackageGroups.SupplierName',
                ],
            }
        },

        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },

        materials() {
            return this.dataMaterials
        },

        orderedMaterials() {
            return this.materials.map((material) => {
                this.isPackagesLoading = false
                return {
                    ...material,
                    ActualArrivalDate: DateTime.fromISO(
                        material.ActualArrival
                    ).toFormat('yyyy-MM-dd'),
                }
            })
        },

        actorPayload() {
            let form = _.cloneDeep(this.form)

            form.gates = this.form.unloadingArea.Checkpoints.map(id => {
                return _.find(this.gates, { CheckpointID: id })
            })

            form.requestedResources = _.uniq(this.requestedResources)

            let accessSets = this.buildAccessSet(form, 'MILKRUN')

            return {
                ActorType: 'MILKRUN',
                MAIsEnabled: true,
                PinCode: form.pinCode,
                LocationValidationDisabled: true,
                AccessSets: accessSets,
                Status: this.form.ActorStatus,
            }
        },

        routePayload() {
            let date = DateTime.fromISO(this.date.toISOString()).toFormat(
                this.dateTimeFormat
            )

            return {
                BLCContainerID: this.selectedContainer.ContainerID,
                DriverUserID: this.routeForm.driver.UserID,
                VehicleID: this.routeForm.vehicle.VehicleID,
                RouteDate: date,
            }
        },

        gates() {
            let gates = this.gatesData.filter((gate) => {
                return gate.DirectionInEnabled || gate.DirectionOutEnabled
            })

            return _.sortBy(gates, 'Name')
        },

        inGates() {
            let gates = _.cloneDeep(this.gates)

            return gates
                .filter((gate) => {
                    return gate.DirectionInEnabled
                })
                .map((gate) => {
                    gate.DirectionOutEnabled = false

                    return gate
                })
        },

        outGates() {
            let gates = _.cloneDeep(this.gates)

            return gates
                .filter((gate) => {
                    return gate.DirectionOutEnabled
                })
                .map((gate) => {
                    gate.DirectionInEnabled = false

                    return gate
                })
        },

        drivers() {
            return this.driversData.map((driver) => {
                return {
                    ...driver,
                    FullName: driver.FirstName + ' ' + driver.LastName,
                }
            })
        },

        vehicles() {
            return this.vehiclesData.map((vehicle) => {
                return {
                    ...vehicle,
                    FullDescription:
                        vehicle.Description + ' (' + vehicle.PlateNo + ')',
                }
            })
        },

        requestedResources() {
            return this.packageGroups
                .map((group) => {
                    return group.RequestedResources
                })
                .reduce((a, b) => a.concat(b), [])
        },

        recipients() {
            return this.recipientData.map((item) => {
                let company = item.Company ? ` (${item.Company})` : ''

                item['Label'] = `${item.FirstName} ${item.LastName}${company}`

                return item
            })
        },

        milkRuns() {
            let milkRuns = []

            for (let route of this.routes) {
                for (let actor of route.Actors) {
                    // sometimes actor is null, if null we don't proceed (backend issue)
                    if (!actor) continue

                    let accessSet = actor.AccessSets && actor.AccessSets[0]
                    let schedule =
                        accessSet &&
                        accessSet.Schedules &&
                        accessSet.Schedules[0]
                    let part =
                        schedule &&
                        schedule.ScheduleParts &&
                        schedule.ScheduleParts[0]

                    if (!accessSet || !schedule || !part) continue

                    let fromTime = DateTime.fromString(
                        part.ValidFrom,
                        this.dateTimeFormat
                    ).toISO()
                    let toTime = DateTime.fromString(
                        part.ValidTo,
                        this.dateTimeFormat
                    ).toISO()

                    milkRuns.push({
                        id: part.SchedulePartID,
                        actorId: actor.ActorID,
                        accessSetId: accessSet.AccessSetID,
                        isSimpleSchedule: part.IsSimpleSchedule,
                        direction: part.Direction,
                        scheduleId: schedule.ScheduleID,
                        routeId: route.BLCRouteID,
                        resourceId: accessSet.UnloadingAreaID,
                        destinationContainerID:
                            accessSet.DestinationContainerID,
                        title: route.Description,
                        actor: actor,
                        route: route,
                        start: fromTime,
                        end: toTime,
                        requestedResources: accessSet.RequestedResources,
                        isExpress: actor.IsExpress || false,
                    })
                }
            }

            return _.uniqBy(milkRuns, 'actorId')
        },

        bookings() {
            let allBookings = [...this.milkRuns]

            for (let actor of this.bookingsData) {
                const accessSet = actor.AccessSets[0]
                const schedule = accessSet.Schedules[0]
                const part = schedule.ScheduleParts[0]

                if (!accessSet || !schedule || !part) continue

                let fromTime = DateTime.fromString(
                    part.ValidFrom,
                    this.dateTimeFormat
                ).toISO()
                let toTime = DateTime.fromString(
                    part.ValidTo,
                    this.dateTimeFormat
                ).toISO()

                allBookings.push({
                    id: part.SchedulePartID,
                    actorId: actor.ActorID,
                    isSimpleSchedule: part.IsSimpleSchedule,
                    direction: part.Direction,
                    accessSetId: accessSet.AccessSetID,
                    scheduleId: schedule.ScheduleID,
                    resourceId: accessSet.UnloadingAreaID,
                    destinationContainerID: accessSet.DestinationContainerID,
                    title: actor.BookingReference,
                    actor: actor,
                    start: fromTime,
                    end: toTime,
                    editable: this.editSlotBookings,
                    requestedResources: accessSet.RequestedResources,
                    isExpress: actor.IsExpress || false,
                })
            }

            if (this.showSlotBookings) {
                return allBookings
            }

            return this.milkRuns
        },

        filledContainers() {
            return this.milkRuns.map((booking) => {
                return _.find(this.containers, {
                    ContainerID:
                        booking.actor.AccessSets[0].DestinationContainerID,
                })
            })
        },

        routeVehicle() {
            return this.vehicles.find((vehicle) => {
                return vehicle.VehicleID == this.route.VehicleID
            })
        },

        config() {
            const self = this
            let scrollTime = '06:00:00'

            return {
                scrollTime,
                slotLabelFormat: 'HH:mm',
                timezone: 'local',
                allDaySlot: false,
                eventOverlap: false,
                schedulerLicenseKey: 'GPL-My-Project-Is-Open-Source',
                defaultView: 'agendaDay',
                resources(callback) {
                    self.collectUnloadingAreas().then((resources) =>
                        callback(resources)
                    )
                },
                resourceRender(resource, element) {
                    element.attr('title', resource.title)
                },
            }
        },

        filteredMaterials() {
            if (this.filterByContainer) {
                return this.materials
            } else {
                return this.materials.filter(
                    (item) =>
                        item.DestinationContainerID ===
                        this.form.unloadingArea.ContainerID
                )
            }
        },

        packageGroupsWithoutHiddenItems() {
            return this.packageGroups.map((item) => {
                return {
                    ...item,
                    PackageItems: item.PackageItems.filter((item) => {
                        return (
                            item.StatusDescription !==
                            'HIDDEN_INVENTORY_TO_STOCK'
                        )
                    }),
                }
            })
        },
        totalPackageItems() {
            let count = 0
            this.packageGroupsWithoutHiddenItems.forEach((group) => {
                count += group.PackageItems.length
            })
            return count
        },
    },

    methods: {
        changeColumnBgColor(column) {
            if (column.columnIndex === 0) {
                switch (column.row.StatusDescription) {
                    case 'DELIVERY_CONFIRMED':
                        return 'background-color: #5ed225 !important'
                    case 'UNABLE_TO_DELIVER':
                        return 'background-color: #f72d2d !important'
                    default:
                        return ''
                }
            }
            return ''
        },
        renderBooking(booking, element) {
            this.hideCalendarPoppers()

            let instance = null
            if (booking && booking.actor) {
                if (booking.actor.ActorType === 'SLOT') {
                    instance = new RoutePlanerSlotEvent({
                        propsData: {
                            booking,
                            element,
                            trans: this.$t,
                        },
                    })
                } else {
                    instance = new RoutePlannerMilkrunEvent({
                        propsData: {
                            booking,
                            element,
                            trans: this.$t,
                            containers: this.containers,
                            route: this.route,
                        },
                    })

                    instance.$on('edit-booking', (booking) => {
                        this.selectBooking(booking)
                        this.currentRangeStart2 = ''
                        this.currentRangeEnd2 = ''
                        this.packageSearchVal2 = ''
                        this.dateTimeRange2 = []
                        this.searchResults2 = this.filteredMaterials
                    })
                    instance.$on('delete-booking', (booking) =>
                        this.deleteBooking(booking)
                    )
                }

                instance.$mount()
                element.eq(0).find('.fc-content').html(instance.$el)
            }
        },

        hideCalendarPoppers() {
            for (const popper of document.querySelectorAll('.tippy-popper')) {
                const instance = popper._tippy

                if (instance && instance.state.visible) {
                    instance.popperInstance.disableEventListeners()
                    instance.hide()
                }
            }
        },

        async selectCalendarBooking() {},
        async selectBooking(booking) {
            if (booking.actor.ActorType === 'SLOT') return

            if (!this.dropped) this.$refs.btnDialog.click()
            this.editing = true

            let resource = _.find(
                this.$refs.calendar.fireMethod('getResources'),
                {
                    id: booking.resourceId,
                }
            )

            this.actor = booking.actor
            this.form.route = booking.route
            this.form.start = booking.start
            this.form.end = booking.end
            this.form.pinCode = booking.actor.PinCode
            this.form.PlateNo = booking.actor.PlateNo
            this.form.dateTimeRange = [booking.start, booking.end]
            this.form.unloadingArea = resource

            const { data } = await this.$http.get(
                `Actor/${booking.actor.ActorID}`
            )

            this.packageGroups = data.PackageGroups || []
            this.originalPackageGroups = _.cloneDeep(data.PackageGroups)
            this.form.ActorStatus = data.Status

            if (this.packageGroups.length) {
                Vue.set(
                    this.packageGroups[0],
                    'RequestedResources',
                    booking.requestedResources
                )
            }

            await this.populateFormInputs(resource)
            this.actor.AccessSets.forEach((accessSet) => {
                this.fillFormAccessSet(accessSet)
            })
        },

        async updateBooking(booking, event) {
            this.dropped = true

            await Promise.all([
                this.updateSchedule(booking),
                this.selectBooking(booking, event),
            ])

            this.submit()
        },

        async addBooking({ start, end, resource }) {
            if (!this.route.BLCRouteID) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$i18n.i18next.t(
                        'message.warning.createOrSelectARouteBeforeCreatingABooking'
                    ),
                })

                return
            }

            setTimeout(() => {
                this.$refs.btnDialog.click()
                this.populateDialog(start, end, resource)
            }, 100)
        },
        async populateDialog(start, end, resource) {
            this.editing = false

            this.resetForm()
            this.form.start = start
            this.form.end = end
            this.form.route = _.find(this.routes, {
                BLCRouteID: this.route.BLCRouteID,
            })
            this.form.pinCode = await this.generatePin()
            this.form.PlateNo = this.routeVehicle.PlateNo
            this.form.dateTimeRange = [start, end]
            this.form.unloadingArea = resource

            this.populateFormInputs(resource)
            this.filterByContainer = false
            this.searchResults2 = this.materials.filter(
                (item) =>
                    item.DestinationContainerID ===
                    this.form.unloadingArea.ContainerID
            )
        },

        async generatePin() {
            let { data } = await this.$http.get('/Util/GeneratePin')

            return data
        },

        fillFormAccessSet(accessSet) {
            accessSet.Schedules.forEach((schedule) => {
                schedule.ScheduleParts.forEach((part) => {
                    let direction = part.Direction.toLowerCase()

                    this.form[`${direction}Gate`] =
                        _.find(this[`${direction}Gates`], {
                            CheckpointID: accessSet['CheckPointID'],
                        }) || ''

                    this.form.recipient = accessSet.RecipientName
                    this.form.recipientCompany = accessSet.RecipientCompany
                    this.form.recipientPhone = accessSet.RecipientPhone
                    this.form.requestedResources = accessSet.RequestedResources
                })
            })
        },

        async fetchRoutes() {
            let container = this.selectedContainer

            if (!_.isEmpty(container) && this.date) {
                let date = DateTime.fromISO(this.date.toISOString()).toFormat(
                    this.dateTimeFormat
                )

                let { data } = await this.$http.get(
                    `/BLC/${container.ContainerID}/Route/Date/${date}`
                )

                this.routes = data

                if (this.form.route) {
                    this.form.route =
                        _.find(this.routes, {
                            BLCRouteID: this.form.route.BLCRouteID,
                        }) || ''
                }
            }
        },

        async fetchBookings() {
            let date = DateTime.fromISO(this.date.toISOString())
            let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

            let dateTimeFrom = date.startOf('day').toFormat(dateTimeFormat)
            let dateTimeTo = date.endOf('day').toFormat(dateTimeFormat)

            let { data } = await this.$http.post(`Actor/Search`, {
                ValidFrom: dateTimeFrom,
                ValidTo: dateTimeTo,
                ActorTypeFilter: ['SLOT'],
                DestinationContainerFilter: [
                    ...this.selectedContainers.map(
                        (container) => container.ContainerID
                    ),
                ],
            })

            this.bookingsData = data
        },

        async fetchMaterials() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/BLC/${container.ContainerID}/Notification/Arrivals`
                )

                this.dataMaterials = data
            }
        },

        async fetchDrivers() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/Container/${container.ContainerID}/User`
                )
                data.sort((a, b) => {
                    if (a && b && a.FirstName && b.FirstName) {
                        return a.FirstName.localeCompare(b.FirstName, 'en', {
                            numeric: true,
                        })
                    }
                })
                this.driversData = data
            }
        },

        async fetchVehicles() {
            let container = this.selectedContainer

            if (!_.isEmpty(container)) {
                let { data } = await this.$http.get(
                    `/Container/${container.ContainerID}/Vehicle`
                )
                data.sort((a, b) => {
                    if (a && b && a.Description && b.Description) {
                        return a.Description.localeCompare(
                            b.Description,
                            'en',
                            { numeric: true }
                        )
                    }
                })
                this.vehiclesData = data
            }
        },

        async collectUnloadingAreas() {
            let unloadingAreas = await this.fetchUnloadingAreas()

            return unloadingAreas
                .filter((area) => area.IsActive)
                .map((area) => {
                    return {
                        id: area.UnloadingAreaID,
                        title:
                            area.ShortDescription +
                            ' - ' +
                            area.container.Description,
                        ...area,
                    }
                })
        },

        async fetchUnloadingAreas() {
            let responses = await Promise.all(
                this.selectedContainers.map((container) => {
                    return this.fetchUnloadingArea(container)
                })
            )

            return responses
                .map((response) => {
                    return response.data
                })
                .reduce((a, b) => a.concat(b), [])
        },

        async fetchUnloadingArea(container) {
            let response = await this.$http.get(
                `Container/${container.ContainerID}/UnloadingArea`
            )
            let data = response.data.map((item) => {
                return {
                    ...item,
                    container,
                }
            })
            response.data = data

            return response
        },

        async fetchAllContainers() {
            let { data } = await this.$http.get('Container')

            this.containers = data
        },

        async fetchAllUnloadingAreas() {
            let { data } = await this.$http.get(`UnloadingArea`)
            this.allUnloadingAreas = data
        },

        async populateFormInputs(container) {
            this.form.unloadingAreas = await this.fetchUnloadingAreas(
                container.ContainerID
            )

            this.form.unloadingAreas = this.form.unloadingAreas.filter(
                (unloadingArea) =>
                    unloadingArea.IsActive &&
                    unloadingArea.ContainerID === container.ContainerID
            )

            this.ContainerID = container.ContainerID
            let [recipients, checkpoints, vehicle] = await Promise.all([
                this.fetchRecipients(container),
                this.fetchCheckPoints(container),
                this.fetchVehicle(this.form.route.VehicleID),
            ])

            recipients.data.sort((a, b) => {
                if (a && b && a.FirstName && b.FirstName) {
                    return a.FirstName.localeCompare(b.FirstName, 'en', {
                        numeric: true,
                    })
                }
            })

            checkpoints.data.sort((a, b) => {
                if (a && b && a.Name && b.Name) {
                    return a.Name.localeCompare(b.Name, 'en', { numeric: true })
                }
            })

            this.recipientData = recipients.data
            this.gatesData = checkpoints.data
            this.form.vehicle = vehicle.data
        },

        async submitAndClose() {
            await this.submit()
            this.closeDialog()
        },

        async submit() {
            if (!this.dropped) this.saving = true

            try {
                let container = this.selectedContainer
                let method = this.editing ? 'put' : 'post'
                let url = this.editing
                    ? `/Actor/${this.actor.ActorID}`
                    : `/BLC/${container.ContainerID}/Route/${this.form.route.BLCRouteID}/Actor`

                let response = await this.$http[method](url, this.actorPayload)

                if (!this.editing) {
                    let { data } = await this.$http.get(
                        `/Actor/${response.data}`
                    )
                    this.actor = data
                    this.form.ActorStatus = this.actor.Status
                }

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: this.$i18n.i18next.t('text.booking'),
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: this.$i18n.i18next.t('text.booking'),
                          }),
                })

                this.fetchRoutes()
            } catch (e) {
                if (e === false || e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }

            this.saving = false
            this.dropped = false
            this.editing = true
        },

        async updateSchedule(schedule) {
            let fromTime = DateTime.fromISO(
                schedule.start.toISOString()
            ).toFormat(this.dateTimeFormat)
            let toTime = DateTime.fromISO(schedule.end.toISOString()).toFormat(
                this.dateTimeFormat
            )

            await this.$http.put(
                `Actor/${schedule.actorId}/AccessSet/${schedule.accessSetId}/Schedule/${schedule.scheduleId}/SchedulePart/${schedule.id}`,
                {
                    Direction: schedule.direction,
                    IsSimpleSchedule: schedule.isSimpleSchedule,
                    ValidFrom: fromTime,
                    ValidTo: toTime,
                }
            )
        },

        async deleteBooking(booking) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'Booking',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                let actorId = this.actor.ActorID
                if (!actorId) {
                    actorId = booking.actor.ActorID
                }

                await this.$http.delete(`/Actor/${actorId}`)
                await this.fetchRoutes()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'Booking',
                    }),
                })

                this.closeDialog()
            } catch (e) {
                console.error(e)
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        async submitRoute() {
            if (!this.routePayload.DriverUserID) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$t('form.validation.required', {
                        name: this.$t('table.column.driver'),
                    }),
                })
                return
            }

            if (!this.routePayload.VehicleID) {
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.$t('form.validation.required', {
                        name: this.$t('table.column.vehicle'),
                    }),
                })
                return
            }

            this.saving = true

            try {
                let container = this.selectedContainer
                let method = this.editing ? 'put' : 'post'
                let url = this.editing
                    ? `/BLC/${container.ContainerID}/Route/${this.route.BLCRouteID}`
                    : `/BLC/${container.ContainerID}/Route`

                await this.$http[method](url, this.routePayload)

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.editing
                        ? this.$i18n.i18next.t('message.success.updated', {
                              section: 'Route',
                          })
                        : this.$i18n.i18next.t('message.success.created', {
                              section: 'Route',
                          }),
                })

                this.resetRoute()
                this.fetchRoutes()
            } catch (e) {
                if (e === false || e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: `${e.response.data}.`,
                    })
                }
            }

            this.saving = false
            this.editing = false
        },

        async deleteRoute(route) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'Route',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let container = this.selectedContainer
                await this.$http.delete(
                    `BLC/${container.ContainerID}/Route/${route.BLCRouteID}`
                )
                await this.fetchRoutes()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'Route',
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },

        editRoute(route) {
            this.editing = true
            this.route = route

            this.routeForm.driver = _.find(this.drivers, {
                UserID: route.DriverUserID,
            })
            this.routeForm.vehicle = _.find(this.vehicles, {
                VehicleID: route.VehicleID,
            })
        },

        resetRoute() {
            this.routeForm.driver = ''
            this.routeForm.vehicle = ''
            this.route = ''

            this.editing = false
        },
        // Move package group to Actor by drag and dropping
        async movePackageGroupToActor(e) {
            console.log(
                '[movePackageGroupToActor] (via drag & drop) ',
                e.item.dataset.package
            )
            if (e.item.dataset.package) {
                let packageItemIdList = []
                let packageGroupBLCNotificationID
                let packageGroupPackageGroupID
                let packageItems = []
                let packageGroup
                this.packageGroups.forEach((group) => {
                    if (group.PackageGroupID === e.item.dataset.package) {
                        packageGroupBLCNotificationID = group.OriginatingBlcNotificationID
                        packageGroupPackageGroupID = group.PackageGroupID
                        group.PackageItems.forEach((item) => {
                            item.StatusDescription = 'ALLOCATED_TO_ACTOR'
                            packageItemIdList.push(item.PackageItemID)
                            packageItems.push(item)
                        })
                        packageGroup = group
                    }
                })

                // Refresh package groups in Actor/Right side. In case the package is partially already there.
                this.packageGroups = this.packageGroups.filter(
                    (x) => x.PackageGroupID !== e.item.dataset.package
                )

                packageGroup.PackageItems = packageItems
                this.packageGroups.push(packageGroup)

                const data = {
                    BLCContainerID: this.selectedContainer.ContainerID,
                    BLCNotificationID: packageGroupBLCNotificationID,
                    ActorID: this.actor.ActorID,
                    PackageGroupID: packageGroupPackageGroupID,
                    PackageItemID: packageItemIdList,
                }
                await this.$http.post(`/BLC/PackageGroupCopyToActor`, data)
                await this.fetchMaterials()
            }
        },
        // Move package group to Actor on the arrow icon button click
        async movePackageGroupToActor2(packageGroupId) {
            this.showMovePkgGrpIcon = false
            let packageGroup
            this.searchResults2.forEach((result) => {
                result.PackageGroups.forEach((group) => {
                    if (group.PackageGroupID === packageGroupId) {
                        packageGroup = group
                    }
                })
            })
            if (!packageGroup) {
                this.showMovePkgGrpIcon = true
                return
            }
            const data = {
                BLCContainerID: this.selectedContainer.ContainerID,
                BLCNotificationID: packageGroup.OriginatingBlcNotificationID,
                ActorID: this.actor.ActorID,
                PackageGroupID: packageGroup.PackageGroupID,
                PackageItemID: _.map(
                    packageGroup.PackageItems,
                    'PackageItemID'
                ),
            }
            await this.$http.post(`/BLC/PackageGroupCopyToActor`, data)
            await this.fetchMaterials()
            this.$nextTick(() => {
                // Refresh search list
                this.refreshListOnSearch()
                // Refresh package groups in actor
                packageGroup.PackageItems.forEach((item) => {
                    item.StatusDescription = 'ALLOCATED_TO_ACTOR'
                })
                this.packageGroups.forEach((group) => {
                    if (group.PackageGroupID === packageGroup.PackageGroupID) {
                        // If package group already exists in the list, add those data to current package
                        packageGroup.PackageItems.push(...group.PackageItems)
                    }
                })
                // Remove existing package in any
                this.packageGroups = this.packageGroups.filter(
                    (x) => x.PackageGroupID !== packageGroup.PackageGroupID
                )
                this.packageGroups.push(packageGroup)
                this.showMovePkgGrpIcon = true
            })
        },
        // Move package item to Actor on the arrow icon button click
        async movePackageItemToActor(packageItemId, packageGroupId) {
            this.showMovePkgItemIcon = false
            let packageGroup
            this.searchResults2.forEach((result) => {
                result.PackageGroups.forEach((group) => {
                    if (group.PackageGroupID === packageGroupId) {
                        packageGroup = group
                    }
                })
            })
            if (!packageGroup) {
                this.showMovePkgItemIcon = true
                return
            }

            const data = {
                BLCContainerID: this.selectedContainer.ContainerID,
                BLCNotificationID: packageGroup.OriginatingBlcNotificationID,
                ActorID: this.actor.ActorID,
                PackageGroupID: packageGroup.PackageGroupID,
                PackageItemID: [packageItemId],
            }
            await this.$http.post(`/BLC/PackageGroupCopyToActor`, data)
            await this.fetchMaterials()
            this.$nextTick(() => {
                // Refresh search list
                this.refreshListOnSearch()
                // Refresh package groups in actor
                let existingPkgGroups = _.cloneDeep(this.packageGroups)

                let existingPkgGrp = _.find(existingPkgGroups, {
                    PackageGroupID: packageGroup.PackageGroupID,
                })

                if (existingPkgGrp) {
                    let packageItemMatch = _.find(packageGroup.PackageItems, {
                        PackageItemID: packageItemId,
                    })
                    packageItemMatch.StatusDescription = 'ALLOCATED_TO_ACTOR'
                    existingPkgGrp.PackageItems.push(packageItemMatch)
                } else {
                    let newPackageGroup = _.cloneDeep(packageGroup)
                    let packageItemMatch = _.find(
                        newPackageGroup.PackageItems,
                        {
                            PackageItemID: packageItemId,
                        }
                    )
                    newPackageGroup.PackageItems = []
                    packageItemMatch.StatusDescription = 'ALLOCATED_TO_ACTOR'
                    newPackageGroup.PackageItems.push(packageItemMatch)
                    existingPkgGroups.push(newPackageGroup)
                }
                this.packageGroups = []
                this.packageGroups = existingPkgGroups
                this.showMovePkgItemIcon = true
            })
        },
        // Move package items within the same draggable component/search result list
        async movePackageItem(e) {
            console.log('[movePackageItem] ', e.item.dataset)
            let toPackageGroup, firstElPackageGroup
            toPackageGroup = firstElPackageGroup =
                e.to.firstChild.dataset.packageGroup

            const lastElPackageGroup = e.to.lastChild.dataset.packageGroup
            const fromPackageGroup = e.item.dataset.packageGroup
            const packageItem = e.item.dataset.packageItem

            if (firstElPackageGroup == fromPackageGroup) {
                toPackageGroup = lastElPackageGroup
            }

            await this.movePackageItemToNewPackageGroup(
                fromPackageGroup,
                toPackageGroup,
                packageItem
            )

            this.fetchMaterials()
        },

        async movePackageItemToNewPackageGroup(
            fromPackageGroup,
            toPackageGroup,
            packageGroupItem
        ) {
            try {
                await this.$http.put(
                    `/MovePackageItem/FromPackageGroup/${fromPackageGroup}/ToPackageGroup/${toPackageGroup}/PackgeItem/${packageGroupItem}`
                )

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.updated'),
                })
            } catch ({ response: { status } }) {
                switch (status) {
                    case 404:
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.packageNotFound'
                            ),
                        })
                        break

                    case 420:
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.packageItemNotInSameBLC'
                            ),
                        })
                        break

                    case 421:
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.packageNotInCreateStatus'
                            ),
                        })
                        break

                    default:
                        this.$message({
                            type: 'error',
                            showClose: true,
                            message: this.$i18n.i18next.t(
                                'message.error.general'
                            ),
                        })
                }
            }
        },

        async movePackageToNotification(packageGroup) {
            const data = {
                BLCContainerID: this.selectedContainer.ContainerID,
                BLCNotificationID: packageGroup.OriginatingBlcNotificationID,
                ActorID: this.actor.ActorID,
                PackageGroupID: packageGroup.PackageGroupID,
                PackageItemID: _.map(
                    packageGroup.PackageItems,
                    'PackageItemID'
                ),
            }
            await this.$http.post(`/Actor/PackageGroupRemoveFromActor`, data)
            this.submit()
            await this.fetchMaterials()

            this.$nextTick(() => {
                let pkgGroups = _.cloneDeep(this.packageGroups)
                _.remove(pkgGroups, {
                    PackageGroupID: packageGroup.PackageGroupID,
                })
                this.packageGroups = []
                this.packageGroups = pkgGroups
                this.resetDate('dateRange2')
            })
        },

        showMovePackageToNotification(packageItems) {
            let show = true
            packageItems.forEach((item) => {
                if (item.StatusDescription === 'DELIVERY_CONFIRMED') {
                    show = false
                }
            })
            return show
        },

        fetchRecipients(container) {
            return this.$http.get(`Container/${container.ContainerID}/User`)
        },

        fetchCheckPoints(container) {
            return this.$http.get(
                `Container/${container.ContainerID}/Checkpoint`
            )
        },

        fetchVehicle(id) {
            return this.$http.get(`Vehicle/${id}`)
        },

        closeDialog() {
            this.dialog = false
            this.editing = false

            this.resetForm()
            this.fetchRoutes()
            this.fetchMaterials()
        },

        resetForm() {
            this.actor = {
                ActorID: '',
            }
            this.gatesData = []
            this.recipientData = []
            this.packageGroups = []
            this.originalPackageGroups = []
            this.form.route = ''
            this.form.pinCode = ''
            this.form.PlateNo = ''
            this.form.vehicle = ''
            this.form.recipient = ''
            this.form.unloadingArea = ''
            this.form.recipientPhone = ''
            this.form.recipientCompany = ''
            this.form.requestedResources = []
        },

        prevDate() {
            this.date = DateTime.fromISO(this.date.toISOString())
                .minus({ days: 1 })
                .toJSDate()
        },

        nextDate() {
            this.date = DateTime.fromISO(this.date.toISOString())
                .plus({ days: 1 })
                .toJSDate()
        },

        today() {
            this.date = DateTime.local().toJSDate()
        },

        tomorrow() {
            this.date = DateTime.local().plus({ days: 1 }).toJSDate()
        },

        async handleBeforeClearAll() {
            try {
                await this.$confirm(
                    'Are you sure you want clear the fields?',
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )
                return true
            } catch (e) {
                return false
            }
        },
        openMaterialDialog(material) {
            if (
                this.selectedContainer.ContainerID &&
                material &&
                material.BLCNotificationID
            ) {
                this.materialManagerListComponent = 'stc-material-manager-list'
                this.materialDialog = true
                this.blcNotification = {
                    containerID: this.selectedContainer.ContainerID,
                    bLCNotificationID: material.BLCNotificationID,
                }
            }
        },
        closeMaterialDialog() {
            this.materialManagerListComponent = ''
            this.materialDialog = false
            this.blcNotification = undefined
            this.fetchMaterials()
        },
        async deletePackageGroup(packageGroup) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'Package Group',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let container = this.selectedContainer
                await this.$http.delete(
                    `BLC/${container.ContainerID}/Notification/${packageGroup.OriginatingBlcNotificationID}/PackageGroup/${packageGroup.PackageGroupID}`
                )
                await this.fetchMaterials()
                this.refreshListOnSearch()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'Package Group',
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },
        async deletePackageItem(packageGroup, item) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'Package Item',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                let container = this.selectedContainer
                await this.$http.delete(
                    `BLC/${container.ContainerID}/Notification/${packageGroup.OriginatingBlcNotificationID}/PackageGroup/${packageGroup.PackageGroupID}/PackageItem/${item.PackageItemID}`
                )
                await this.fetchMaterials()
                this.refreshListOnSearch()

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.$i18n.i18next.t('message.success.deleted', {
                        section: 'Package Item',
                    }),
                })
            } catch (e) {
                if (e === 'cancel') {
                    //
                } else {
                    this.$message({
                        type: 'error',
                        showClose: true,
                        message: this.$i18n.i18next.t('message.error.general'),
                    })
                }
            }
        },
        updatePackageGroupSearchList() {
            this.searchResults = this.orderedMaterials
            this.isPackagesLoading = false
        },
        async dateTimeRangeChange(range) {
            if (range && range.length === 2) {
                this.currentRangeStart = moment(range[0]).format('YYYY-MM-DD')
                this.currentRangeEnd = moment(range[1]).format('YYYY-MM-DD')
                this.searchResults = _.filter(this.orderedMaterials, (item) =>
                    moment(
                        moment(item.ActualArrival).format('YYYY-MM-DD')
                    ).isBetween(
                        this.currentRangeStart,
                        this.currentRangeEnd,
                        'days',
                        '[]'
                    )
                )
                if (this.packageSearchVal !== '') {
                    this.searchResults = await this.$search(
                        this.packageSearchVal,
                        this.searchResults,
                        this.searchOptions
                    )
                }
            } else {
                this.resetDate('dateRange1')
            }
        },
        async dateTimeRangeChange2(range) {
            if (range && range.length === 2) {
                this.currentRangeStart2 = moment(range[0]).format('YYYY-MM-DD')
                this.currentRangeEnd2 = moment(range[1]).format('YYYY-MM-DD')
                const results = _.filter(this.filteredMaterials, (item) =>
                    moment(
                        moment(item.ActualArrival).format('YYYY-MM-DD')
                    ).isBetween(
                        this.currentRangeStart2,
                        this.currentRangeEnd2,
                        'days',
                        '[]'
                    )
                )
                if (results) {
                    if (this.packageSearchVal2 !== '') {
                        this.searchResults2 = await this.$search(
                            this.packageSearchVal2,
                            results,
                            this.searchOptions
                        )
                    } else {
                        this.searchResults2 = results
                    }
                }
            } else {
                this.resetDate('dateRange2')
            }
        },
        async refreshListOnSearch() {
            if (this.packageSearchVal !== '') {
                this.searchResults = await this.$search(
                    this.packageSearchVal,
                    this.orderedMaterials,
                    this.searchOptions
                )
                if (this.currentRangeStart && this.currentRangeEnd) {
                    this.searchResults = _.filter(this.searchResults, (item) =>
                        moment(
                            moment(item.ActualArrival).format('YYYY-MM-DD')
                        ).isBetween(
                            this.currentRangeStart,
                            this.currentRangeEnd,
                            'days',
                            '[]'
                        )
                    )
                }
            } else {
                this.updatePackageGroupSearchList()
            }

            if (this.packageSearchVal2 !== '') {
                this.searchResults2 = await this.$search(
                    this.packageSearchVal2,
                    this.filteredMaterials,
                    this.searchOptions
                )
                if (this.currentRangeStart2 && this.currentRangeEnd2) {
                    this.searchResults2 = _.filter(
                        this.searchResults2,
                        (item) =>
                            moment(
                                moment(item.ActualArrival).format('YYYY-MM-DD')
                            ).isBetween(
                                this.currentRangeStart2,
                                this.currentRangeEnd2,
                                'days',
                                '[]'
                            )
                    )
                }
            } else {
                this.searchResults2 = this.filteredMaterials
            }
        },
        async resetDate(type) {
            if (type === 'dateRange1') {
                this.currentRangeStart = ''
                this.currentRangeEnd = ''
                this.dateTimeRange = []
                this.searchResults = this.orderedMaterials
                if (this.packageSearchVal !== '') {
                    this.searchResults = await this.$search(
                        this.packageSearchVal,
                        this.searchResults,
                        this.searchOptions
                    )
                }
            } else {
                this.currentRangeStart2 = ''
                this.currentRangeEnd2 = ''
                this.dateTimeRange2 = []
                this.searchResults2 = this.filteredMaterials
                if (this.packageSearchVal2 !== '') {
                    this.searchResults2 = await this.$search(
                        this.packageSearchVal2,
                        this.searchResults2,
                        this.searchOptions
                    )
                }
            }
        },
        async returnPackageItem(item, packageGroup) {
            if (packageGroup.PackageItems.length === 1) {
                this.movePackageToNotification(packageGroup)
            } else {
                const data = {
                    BLCContainerID: this.selectedContainer.ContainerID,
                    BLCNotificationID:
                        packageGroup.OriginatingBlcNotificationID,
                    ActorID: this.actor.ActorID,
                    PackageGroupID: packageGroup.PackageGroupID,
                    PackageItemID: [item.PackageItemID],
                }
                await this.$http.post(
                    `/Actor/PackageGroupRemoveFromActor`,
                    data
                )
                await this.fetchMaterials()
                this.$nextTick(() => {
                    let pkgGroups = _.cloneDeep(this.packageGroups)
                    pkgGroups.forEach((group) => {
                        if (group.PackageItems) {
                            _.remove(group.PackageItems, {
                                PackageItemID: item.PackageItemID,
                            })
                        }
                    })
                    this.packageGroups = []
                    this.packageGroups = pkgGroups
                    this.resetDate('dateRange2')
                })
            }
        },
    },
}
</script>

<style>
.Status_Success {
    background: #236b6660;
}

.Status_Partial {
    background: #f9a82560;
}
.Light_Blue_Color1 {
    color: #90caf9 !important;
}
</style>
<style scoped>
.el-collapse-item__header-content {
    width: 100%;
}
.el-collapse >>> .el-collapse-item__header {
    background-color: #323b49 !important;
}
.el-collapse >>> .el-collapse-item__header.is-active {
    background-color: #fee191 !important;
}
.el-form-card__package-item {
    padding-left: 10px;
}
.el-collapse >>> .el-collapse-item__content {
    padding-left: 10px !important;
}
/* .fc-time-grid-event.fc-allow-mouse-resize .fc-resizer{
        bottom: 20px !important;
    }*/
.el-collapse >>> .el-collapse-item__header:hover .delete-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse >>> .el-collapse-item__content-item:hover .delete-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse >>> .el-collapse-item__header:hover .move-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse >>> .el-collapse-item__content-item:hover .move-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse >>> .el-collapse-item__header:hover .copy-package-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse >>> .el-collapse-item__header:hover .copy-package-icon:hover {
    font-weight: bolder;
    color: green;
    font-size: 15px;
}

.el-collapse >>> .el-collapse-item__content-item:hover .copy-package-icon {
    visibility: visible;
    opacity: 1;
}

.el-collapse
    >>> .el-collapse-item__content-item:hover
    .copy-package-icon:hover {
    font-weight: bolder;
    color: green;
    font-size: 15px;
}

.el-collapse >>> .el-collapse-item__content-item:hover {
    background-color: #f9d981;
}

.el-collapse >>> .el-collapse-item__header:hover {
    background-color: #f9d981;
}

.delete-icon {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.1s linear, opacity 0.1s linear;
    float: right;
    margin-top: 10px;
    font-size: 14px;
    color: red;
    cursor: pointer;
}
.copy-package-icon {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.1s linear, opacity 0.1s linear;
    float: right;
    margin-top: 10px;
    font-size: 14px;
    color: #34c8b4;
    cursor: pointer;
}
.move-icon {
    margin-top: 6px;
    margin-right: 5px;
    color: black;
    font-size: 14px;
    opacity: 0;
    transition: visibility 0.1s linear, opacity 0.1s linear;
}
.date-refresh-icon {
    color: #989ea6;
    cursor: pointer;
}
.el-range-editor--mini.el-input__inner {
    background: transparent !important;
}
.el-date-editor {
    width: 250px !important;
}
.el-input__inner {
    font-weight: normal !important;
}
.input-group__input input {
    font-weight: normal !important;
}
</style>
